<template>
  <div id="Bank-account_add" class="group-setup">
    <v-progress-linear
      indeterminate
      color="blue"
      v-if="loading"
    ></v-progress-linear>

    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>

    <v-form v-if="!loading">
      <v-row>
        <v-col cols="12">
          <v-card class="pa-5" flat>
            <HeaderDividerBlock headerText="Add Company Bank Account" />
            <v-row>
              <v-col cols="6">
                <p class="text-title">Bank</p>
                <v-autocomplete
                  v-model="form.bank_id"
                  :items="bankOptions"
                  item-text="bank_name"
                  item-value="id"
                  placeholder="Select Bank"
                  outlined
                  dense
                  required
                  @change="onBankChange"
                />
              </v-col>

              <v-col cols="6">
                <p class="text-title">Account Number</p>
                <v-text-field
                  v-model="form.account_number"
                  placeholder="Enter Account Number"
                  outlined
                  dense
                  required
                  clearable
                />
              </v-col>

              <v-col cols="6">
                <p class="text-title">Account Type</p>
                <v-select
                  v-model="form.account_type"
                  :items="['Savings', 'Checking']"
                  placeholder="Select Account Type"
                  outlined
                  dense
                  required
                />
              </v-col>

              <v-col cols="6">
                <p class="text-title">IFSC Code</p>
                <v-text-field
                  v-model="form.ifsc_code"
                  placeholder="Enter IFSC Code"
                  outlined
                  dense
                  clearable
                />
              </v-col>

              <v-col cols="6">
                <p class="text-title">Branch</p>
                <v-autocomplete
                  v-model="form.branch_id"
                  :items="branches"
                  item-text="name"
                  item-value="id"
                  placeholder="Select Branch"
                  outlined
                  dense
                  required
                />
              </v-col>

              <v-col cols="6">
                <p class="text-title">Currency</p>
                <v-autocomplete
                  v-model="form.currency_id"
                  :items="currencies"
                  item-text="name"
                  item-value="id"
                  placeholder="Select Currency"
                  outlined
                  dense
                  required
                />
              </v-col>

              <v-col cols="6">
                <p class="text-title">Starting Balance</p>
                <v-text-field
                  v-model="form.starting_balance"
                  placeholder="Enter Starting Balance"
                  type="number"
                  outlined
                  dense
                  required
                  clearable
                />
              </v-col>

              <v-col cols="6">
                <p class="text-title">Country</p>
                <v-autocomplete
                  v-model="form.country_id"
                  :items="countries"
                  item-text="country_name"
                  item-value="id"
                  placeholder="Select Country"
                  outlined
                  dense
                  required
                />
              </v-col>

              <v-col cols="6">
                <p class="text-title">Is Active</p>
                <v-switch
                  v-model="form.is_active"
                  label="Active"
                  color="green"
                  dense
                  inset
                />
              </v-col>
            </v-row>

            <v-card-actions class="mt-10">
              <v-row>
                <v-col cols="12" md="10"></v-col>
                <v-col cols="12" md="2">
                  <v-btn
                    large
                    color="#00B3FF"
                    dark
                    depressed
                    block
                    @click="submit"
                    >Add Bank Account</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
    <v-dialog v-model="bankDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Add New Bank</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="newBank.bank_name"
            label="Bank Name"
            required
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="createBank">Save</v-btn>
          <v-btn text @click="bankDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snackbars
      :text="succesMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import { checkError } from "@/config/errors.js";
import { CompanyBankService } from "@/services/bank-service";

export default {
  name: "AddCompanyBankAccount",
  components: { Alert, Snackbars, HeaderDividerBlock },
  data() {
    return {
      loading: false,
      errors: null,
      snackbar: false,
      succesMsg: "",
      form: {
        bank_id: "",
        account_number: "",
        account_type: "",
        ifsc_code: "",
        branch_id: null,
        currency_id: null,
        starting_balance: "",
        country_id: null,
        is_active: true,
      },
      bankDialog: false,
      newBank: {
        bank_name: "",
      },
      banks: [],
      branches: [],
      currencies: [],
      countries: [],
    };
  },
  created() {
    this.fetchDropdownData();
  },
  computed: {
    bankOptions() {
      return [{ id: "add_new", bank_name: "➕ Add New Bank" }, ...this.banks];
    },
  },
  methods: {
    async fetchDropdownData() {
      try {
        const banks = await CompanyBankService.getBanks();
        const branches = await CompanyBankService.getBranches();
        const currencies = await CompanyBankService.getCurrencies();
        const countries = await CompanyBankService.getCountries();

        this.branches = branches.data;
        this.currencies = currencies.data;
        this.countries = countries.data;
        this.banks = banks.data;
      } catch (err) {
        console.error(err);
        this.errors =
          err.response?.data || "Error fetching products or GRN list.";
      }
    },

    async submit() {
      this.loading = true;
      this.errors = null;
      this.loading = true;
      this.errors = null;
      try {
        await CompanyBankService.create(this.form);
        this.succesMsg = "Bank Account added successfully!";
        this.snackbar = true;
        this.resetForm();
      } catch (error) {
        this.loading = false;
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
        window.scrollTo(0, 0);
      } finally {
        this.loading = false;
      }
    },

    onBankChange(val) {
      if (val === "add_new") {
        this.bankDialog = true;
        this.form.bank_id = null;
      }
    },
    async createBank() {
      try {
        const response = await CompanyBankService.createBank(this.newBank);
        if (response.data && response.data.data) {
          this.banks.unshift(response.data.data);
          this.form.bank_id = response.data.data.id;
          this.bankDialog = false;
          this.newBank = { bank_name: "" };
        }
      } catch (err) {
        this.errors = err.response?.data || "Error creating bank.";
      }
    },

    resetForm() {
      this.form = {
        bank_id: "",
        account_number: "",
        account_type: "",
        ifsc_code: "",
        branch_id: null,
        currency_id: null,
        starting_balance: "",
        country_id: null,
        is_active: true,
      };
    },

    closeSnackbar() {
      this.snackbar = false;
    },
  },
};
</script>
